import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { FetchTypes, Localization, SliceTypes } from 'utils';
import { RootState } from './rootReducer';
import { updateNotification } from './serviceSlice';
import axios from 'axios';
import { sidePanelInitial } from './InitialStates/sidePanelInitial';
import { BASE_REACT_APP_CF_CORE_LEARNING_SCREENS } from '../App';

export const fetchTortoiseData: any = createAsyncThunk(
    FetchTypes.TORTOISE,
    async (
        params: any,
        thunkApi: any,
    ): Promise<{ data: any; tab: string; localization: Localization }> => {
        const { sidePanelPayload, tab, localization } = params;
        try {
            const { data } = await axios.post(BASE_REACT_APP_CF_CORE_LEARNING_SCREENS, {
                animal: 'tortoise',
                ...sidePanelPayload,
            });

            return { data, tab, localization };
        } catch (err: any) {
            console.error(err);
            thunkApi.dispatch(
                updateNotification({
                    type: 'error',
                    header: 'Tortoise CF',
                    message: `Something went wrong!`,
                }),
            );
            throw err;
        }
    },
);

export const sidePanelsSlice = createSlice({
    name: SliceTypes.SIDEPANEL,
    initialState: sidePanelInitial,
    reducers: {
        updatePanelSelection: (
            state,
            {
                payload: { property, value, localization },
            }: PayloadAction<{
                property: string;
                value: string | any;
                localization: Localization;
            }>,
        ) => {
            const statePanel = state[localization];

            state[localization] = {
                ...statePanel,
                selectionState: {
                    ...statePanel.selectionState,
                    [property]: value,
                },
            };
        },
        updatePanelSubcategorySelection: (
            state,
            {
                payload: { property, value, localization },
            }: PayloadAction<{
                property: string;
                value: string | any;
                localization: Localization;
            }>,
        ) => {
            const statePanel = state[localization];

            state[localization] = {
                ...statePanel,
                selectionState: {
                    ...statePanel.selectionState,
                    dropDownAllSubcategories: {
                        ...statePanel.selectionState.dropDownAllSubcategories,
                        [property]: value,
                    },
                },
            };
        },
        resetSidePanel: (
            state,
            {
                payload: { localization },
            }: PayloadAction<{
                localization: Localization;
            }>,
        ) => {
            const statePanel = state[localization];
            state[localization] = {
                ...statePanel,
                selectionState: { ...statePanel.defaultSidePanelState },
            };
        },
    },

    extraReducers(builder) {
        builder.addCase(fetchTortoiseData.pending, (state, { meta: { arg } }) => {
            const { localization } = arg;
            const statePanel = state[localization];
            state[localization] = {
                ...statePanel,
                isTortoiseLoading: true,
                error: false,
            };
        });
        builder.addCase(fetchTortoiseData.fulfilled, (state, { payload }) => {
            const { data, localization } = payload;
            const statePanel = state[localization];

            state[localization] = {
                ...statePanel,
                tortoiseResponse: { ...data },
                isTortoiseLoading: false,
                isTortoiseLoaded: true,
            };
        });
        builder.addCase(fetchTortoiseData.rejected, (state, { meta: { arg } }) => {
            const { localization } = arg;
            const statePanel = state[localization];
            state[localization] = {
                ...statePanel,
                isTortoiseLoading: false,
                isTortoiseLoaded: true,
                error: true,
            };
        });
    },
});

export const { updatePanelSelection, updatePanelSubcategorySelection, resetSidePanel } =
    sidePanelsSlice.actions;

export const sidePanelSlice = (state: RootState) => state.sidePanel;

export default sidePanelsSlice.reducer;
